module.exports = __webpack_public_path__ + "img/type8.99ce28a9.png";